import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from './../../../../environments/environment';
import { CustomPfService } from '../custom-pf.service';
import { AccessGroupService } from './../../access-group.service';
import { LmTsService } from '../../learner-maps/lm-ts.service';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
  selector: 'app-fs-reveal-dashboard',
  templateUrl: './fs-reveal-dashboard.component.html',
  styleUrls: ['./fs-reveal-dashboard.component.scss']
})
export class FsRevealDashboardComponent implements OnInit, OnDestroy {

  env = environment;
  @Output() contentChange = new EventEmitter();
  @Input() obj_container: any;
  main_app_enable = false;
  profiles: any;
  menu_links: any;
  fs_reveal_container: any[] = [];
  loading = false;
  breadcrumb = true;
  placeholderImage = 'assets/images/learner-map-placeholder.svg';

  private destroy$ = new Subject<void>();

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public customPfService: CustomPfService,
    public accessgroup: AccessGroupService,
    public lm_ts: LmTsService,
    public store: Store<any>
  ) {}

  ngOnInit() {
    if (this.router.url.includes('my-account') || this.router.url.includes('fs-admin') || this.router.url.includes('teams-admin')) {
      this.breadcrumb = false;
      this.main_app_enable = true;
      return;
    }

    this.loading = true;

    if (this.router.url.includes('fs-reveal')) {
      this.main_app_enable = true;
      this.loadFsRevealData();
    } else {
      this.loadProfileData();
    }
  }

  private loadFsRevealData() {
    this.store.select<any>((state) => state.profile.accessGroupData).pipe(
      takeUntil(this.destroy$),
      filter(message => !!message)
    ).subscribe(message => {
      this.menu_links = message;
      const dynamicLms = this.menu_links['main_menu']?.dynamic_lms;
      localStorage.setItem('fs_reveal_lm_id', '63');

      this.fs_reveal_container = [
        {
          title: dynamicLms?.presenter_lm?.title,
          img_link: `${this.env.s3_upload}/learner-maps/mindset-reveal/presenter_lm.png`,
          active: dynamicLms?.presenter_lm?.lmproperties,
          lm_id: dynamicLms?.presenter_lm?.value,
          routerlink: 'fs-reveal/presenter-lm'
        },
        {
          title: dynamicLms?.presentation?.title,
          img_link: `${this.env.admin_upload}312/original.jpg?1661422918`,
          active: dynamicLms?.presentation?.lmproperties,
          lm_id: dynamicLms?.presentation?.value,
          routerlink: 'fs-reveal/presentation'
        }
      ];
      this.obj_container = this.fs_reveal_container;
      this.loading = false;
    });
  }

  private loadProfileData() {
    this.store.select<any>((state) => state.profile.tcwaProfile).pipe(
      takeUntil(this.destroy$),
      filter(res => !!res)
    ).subscribe(res => {
      this.profiles = res['profile'];
      const accessGroups = this.profiles?.access_groups_json?.main_menu;

      this.fs_reveal_container = [
        {
          title: accessGroups?.dlm_slideshow?.title,
          img_link: `${this.env.admin_upload}300/original.jpg?1660299027`,
          active: accessGroups?.dlm_slideshow?.lmproperties,
          lm_id: accessGroups?.dlm_slideshow?.value
        },
        {
          title: accessGroups?.dlm_slideshow2?.title,
          img_link: `${this.env.admin_upload}312/original.jpg?1661422918`,
          active: accessGroups?.dlm_slideshow2?.lmproperties,
          lm_id: accessGroups?.dlm_slideshow2?.value
        }
      ];
      this.loading = false;
    });
  }

  onImgError(event: Event) {
    const img = event.target as HTMLImageElement;
    if (img && img.src !== this.placeholderImage) {
      img.src = this.placeholderImage;
    }
  }

  changeContent(content: string, lm_id = '') {
    this.contentChange.emit(content);
    if (lm_id !== '') {
      this.customPfService?.active_lmsd_id.next(lm_id);
    }
  }

  updateRoute(routePath: string) {
    if (routePath.includes('aa-staging.foursightonline.com')) {
      window.open(routePath, '_blank');
    } else {
      this.router.navigate([`${routePath}`]);
      this.lm_ts.an_slide_no.next(0);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
